import React from "react";
import Heading from "../../common/Heading";
import { skillSection } from "../../data";
import { Container, ProficiencyBox } from "./proficiency_element";
import ProficiencyTile from "./Proficiency_Tile";
const Proficiency = () => {
  return (
    <Container id="proficiency">
      <Heading heading="Proficiency" subheading="" />

      <ProficiencyBox>
        {skillSection.proficiency.map((p, i) => {
          return <ProficiencyTile key={i} data={p} />;
        })}
      </ProficiencyBox>
    </Container>
  );
};

export default Proficiency;
